module.exports = __webpack_public_path__ + "static/media/jackpotDefault.fda61018.png";